import React from 'react';
import { Divide as LucideIcon } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  color: 'blue' | 'green' | 'orange' | 'purple' | 'red';
  compact?: boolean;
  dense?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon: Icon,
  color,
  compact = false,
  dense = false
}) => {
  if (dense) {
    return (
      <div className="bg-gradient-to-br from-white to-[#1875FF]/5 rounded-lg border border-[#1875FF]/20 px-2 py-2.5 transition-all hover:shadow-lg hover:border-[#05E0D1] shadow-sm hover:-translate-y-0.5 duration-300">
        <div className="flex flex-col items-center text-center gap-1">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#1875FF]/10 to-[#05E0D1]/10 flex items-center justify-center flex-shrink-0">
            <Icon size={13} className="text-[#1875FF]" />
          </div>
          <p className="text-base font-bold font-metric leading-none bg-clip-text text-transparent bg-gradient-to-r from-[#1875FF] to-[#05E0D1]">{value}</p>
          <p className="text-[10px] leading-tight text-gray-700 font-semibold">{title}</p>
        </div>
      </div>
    );
  }

  if (compact) {
    return (
      <div className="bg-gradient-to-br from-white to-[#1875FF]/5 rounded-xl border-2 border-[#1875FF]/20 p-4 transition-all hover:shadow-2xl hover:border-[#05E0D1] shadow-lg hover:-translate-y-0.5 duration-300">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#1875FF]/10 to-[#05E0D1]/10 flex items-center justify-center flex-shrink-0 shadow-md">
            <Icon size={18} className="text-[#1875FF]" />
          </div>
          <div className="min-w-0">
            <p className="text-xl font-bold font-metric bg-clip-text text-transparent bg-gradient-to-r from-[#1875FF] to-[#05E0D1]">{value}</p>
            <p className="text-xs text-gray-700 font-semibold">{title}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-white to-[#1875FF]/5 rounded-xl border-2 border-[#1875FF]/20 p-5 transition-all hover:shadow-2xl hover:border-[#05E0D1] shadow-lg hover:-translate-y-0.5 duration-300">
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#1875FF]/10 to-[#05E0D1]/10 flex items-center justify-center flex-shrink-0 shadow-md hover:shadow-lg transition-all">
          <Icon size={20} className="text-[#1875FF]" />
        </div>
        <div className="min-w-0">
          <p className="text-2xl font-bold font-metric bg-clip-text text-transparent bg-gradient-to-r from-[#1875FF] to-[#05E0D1]">{value}</p>
          <p className="text-sm text-gray-700 font-semibold">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;